<template>
    <div :class="classObj">
        <h3>
            <slot name="subheader"></slot>
        </h3>
        <div :class="`list-content`">
            <slot></slot>
        </div>                
    </div>
</template>

<script>
    export default {
        name: 'DeviceList',        
        props: {
            titlePos: {
                type: String,
                default: 'left',
                validator(v) {
                    return ["left", "center", "right"].includes(v);
                }
            }
        },       
        computed: {
            classObj() {
                let klass = {}
                klass['gadget-list'] = true              
                return klass
            }
        }
    }
</script>

<style lang="scss" scoped>
.bs-list-content-row {
    display: flex; 
    flex-direction: row; 
    padding: 8px;
    border-bottom: 1px solid lightgray;
    align-items: center;
    &-description {
        min-width: 83px;
        &-icon {
            min-width: 40px;
            max-width: 40px;
            text-align: center;
        }
    }
}
</style>